// extracted by mini-css-extract-plugin
export var chevron = "_ns-1";
export var clickable = "_ns-0";
export var ruleRow = "_ns-2";